// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-6820b92d]{margin-bottom:1em}#contact[data-v-6820b92d]{padding:4em 0 8em}h2.bigTitle[data-v-6820b92d]{font-size:3em;margin-bottom:2em}.form-contain[data-v-6820b92d]{padding:2em;border:1px solid #ddd;background:#ececec}.more-contact div[data-v-6820b92d]{padding:1em 15%}.hbspt-form .hs-form-iframe[data-v-6820b92d]{width:100%!important}", ""]);
// Exports
module.exports = exports;
